var map = {
	"./screen1.png": 288,
	"./screen2.png": 289,
	"./screen3.png": 290,
	"./screen4.png": 291,
	"./screen5.png": 292,
	"./screen6.png": 293,
	"./screen7.png": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 287;